import { MessageType, MAPPABLE_FIELDS_CONFIG } from "./constants";

const getMappableFields = (useCase, messageType = MessageType.sms) => {
	const config = MAPPABLE_FIELDS_CONFIG[useCase];
	if (!config) {
		return [];
	}

	return config[messageType] || config[MessageType.email] || [];
};

export const getMappableFieldsForContext = (useCase, messageType) => {
	return useCase
		? getMappableFields(useCase, messageType)
		: [];
};

// Check if cursor is after a # character and return the partial field name
export const getPartialFieldAtCursor = (text, cursorPosition) => {
	const beforeCursor = text.substring(0, cursorPosition);
	const hashIndex = beforeCursor.lastIndexOf('#');
	
	if (hashIndex === -1) return null;
	
	const textAfterHash = beforeCursor.substring(hashIndex + 1);
	
	// Only consider it a field if it's alphanumeric/underscore
	if (/^[a-zA-Z0-9_]*$/.test(textAfterHash)) {
		return {
			hashIndex,
			partialField: textAfterHash,
			fullMatch: '#' + textAfterHash
		};
	}
	
	return null;
};

// Insert a field at the cursor position, replacing any partial field
export const insertFieldAtCursor = (text, cursorPosition, field) => {
	const partialField = getPartialFieldAtCursor(text, cursorPosition);
	
	if (partialField) {
		// Replace from # to cursor with the complete field
		const beforeHash = text.substring(0, partialField.hashIndex);
		const afterCursor = text.substring(cursorPosition);
		const newText = beforeHash + field + afterCursor;
		const newCursorPosition = partialField.hashIndex + field.length;
		
		return {
			text: newText,
			cursorPosition: newCursorPosition
		};
	}
	
	// If no partial field found, just insert at cursor
	const beforeCursor = text.substring(0, cursorPosition);
	const afterCursor = text.substring(cursorPosition);
	const newText = beforeCursor + field + afterCursor;
	const newCursorPosition = cursorPosition + field.length;
	
	return {
		text: newText,
		cursorPosition: newCursorPosition
	};
};
